import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function transformGqlToAgeRestriction(
    ageRestriction?: LegacyOttTrailerPlayerBaseInfoContent['ageRestriction'] | null
) {
    switch (ageRestriction) {
        case 'age0':
            return '0+' as const;
        case 'age6':
            return '6+' as const;
        case 'age12':
            return '12+' as const;
        case 'age15':
            return '15+' as const;
        case 'age16':
            return '16+' as const;
        case 'age18':
            return '18+' as const;
        case 'age21':
            return '21+' as const;
        case 'g':
            return 'G' as const;
        case 'pg':
            return 'PG' as const;
        case 'pg13':
            return 'PG13' as const;
        case 'pg15':
            return 'PG15' as const;
        default:
            return undefined;
    }
}

const rtlAgeRestrctionMap: Record<string, string> = {
    '0+': '+0',
    '6+': '+6',
    '12+': '+12',
    '15+': '+15',
    '16+': '+16',
    '18+': '+18',
    '21+': '+21',
};

export const transformAgeRestrictionToRtl = (ageRestriction: string | undefined) => {
    if (
        document.dir !== 'rtl' ||
        ageRestriction === undefined ||
        !rtlAgeRestrctionMap[ageRestriction]
    ) {
        return ageRestriction;
    }

    return rtlAgeRestrctionMap[ageRestriction];
};
